import { toString30pk9tzaqopn as toString } from '../Library.mjs';
import {
  Duration__toString_impl_8d916b1pmuuqkmfodll as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz62capomnnb6e8m as Duration__hashCode_impl_u4exz6,
  Duration5ynfiptaqcrg as Duration,
} from './Duration.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var TimedValueClass;
function TimedValue() {
  if (TimedValueClass === VOID) {
    class $ {
      constructor(value, duration) {
        this.qt_1 = value;
        this.rt_1 = duration;
      }
      toString() {
        return 'TimedValue(value=' + toString(this.qt_1) + ', duration=' + Duration__toString_impl_8d916b(this.rt_1) + ')';
      }
      hashCode() {
        var result = this.qt_1 == null ? 0 : hashCode(this.qt_1);
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.rt_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TimedValue()))
          return false;
        if (!equals(this.qt_1, other.qt_1))
          return false;
        if (!equals(new (Duration())(this.rt_1), new (Duration())(other.rt_1)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'TimedValue');
    TimedValueClass = $;
  }
  return TimedValueClass;
}
//region block: exports
export {
  TimedValue as TimedValuew9j01dao9jci,
};
//endregion

//# sourceMappingURL=measureTime.mjs.map
